import React from 'react';

export default function Report() {

    return (<h1>auditor - report</h1>)
}